import {actionTypes, flightTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

var SecurityFlight = {
    time: null,
    list: [],
    error: '',
    load: function (type) {
        return m.request({
            method: 'GET',
            url: '/api/security/flights/' + type
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            SecurityFlight.error = '';

            SecurityFlight.time = response.time;
            SecurityFlight.list = response.flights;

            storage.config = response.config;
            storage.flightType = type;

            server.initPing();

            return response;
        }, function (response) {
            if (response && response.message) {
                SecurityFlight.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    update: function (key, value) {
        SecurityFlight.list[key] = value;
    },
    setWeaponOnBoard: function (key) {
        SecurityFlight.error = '';
        loader.show();

        var flight = SecurityFlight.list[key];

        m.request({
            method: 'PUT',
            url: '/api/flight/' + flight.id + '/weapon'
        }).then(function () {
            loader.hide();

            flight.hasWeapon = true;
            SecurityFlight.update(key, flight);

        }, function (response) {

            cache.push({
                type: actionTypes.setWeapon,
                flightId: flight.id
            });

            if (response && response.message) {
                SecurityFlight.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export var SecurityFlightsPage = {
    controller: function () {

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = SecurityFlight.load(storage.flightType || flightTypes.departure);

        return {
            data: data,
            topMenu: [
                { title: 'Рейсы', url: '/security/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: SecurityFlight.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", SecurityFlight.error),
            m(".container[style='padding: 7px 15px;']", [
                m(".row", [
                    m(".col-xs-6[style='padding: 0 5px 0 10px']", [
                        m("button.btn.btn-success.btn-block[type='text']", {
                            class: storage.flightType == flightTypes.arrival ? 'active' : '',
                            onclick: function () {
                                interval.clearAll();
                                loader.show();
                                SecurityFlight.load(flightTypes.arrival)
                            }
                        }, [
                            m("i.fa.fa-arrow-circle-down"),
                            m.trust('&nbsp;Прилет')
                        ])
                    ]),
                    m(".col-xs-6[style='padding: 0 10px 0 5px']", [
                        m("button.btn.btn-success.btn-block[type='text']", {
                            class: storage.flightType == flightTypes.departure ? 'active' : '',
                            onclick: function () {
                                interval.clearAll();
                                loader.show();
                                SecurityFlight.load(flightTypes.departure)
                            }
                        }, [
                            m("i.fa.fa-arrow-circle-up"),
                            m.trust('&nbsp;Вылет')
                        ])
                    ])
                ])
            ]),
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", "Рейс"),
                        m("th.text-center", "Время"),
                        m("th.text.center", "МС"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    SecurityFlight.list.map(function (flight, i) {
                        return m("tr", [
                            m("td", [
                                m("a.btn.btn-block.btn-default.btn-lg", {
                                        href: flight.url,
                                        config: m.route
                                    },
                                    m("span[style='display:inline-block;padding-left:7px;']", [
                                        m('span', flight.boardNumber),
                                        m("br"),
                                        flight.type === flightTypes.departure ?
                                            m('img', {src: "/img/departure.png"}) : m.trust(flight.airportCode + '&nbsp;'),
                                        flight.type === flightTypes.departure ?
                                            m.trust('&nbsp;' + flight.airportCode) : m('img', {src: "/img/arrival.png"})
                                    ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.time),
                                m("br"),
                                m("span", flight.date)
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.parkingNumber),
                                m("br"),
                                m("span", flight.typeVS)
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                flight.hasWeapon ?
                                    m("button.btn.btn-danger.btn-lg", [
                                        m("i.fa.fa-2x.fa-fire")
                                    ]) :
                                    m("button.btn.btn-info.btn-lg", {
                                        onclick: function () {
                                            SecurityFlight.setWeaponOnBoard(i);
                                        }
                                    }, [
                                        m("i.fa.fa-2x.fa-fire")
                                    ])
                            ])
                        ])
                    })
                ])
            ])
        ]
    }
};
